export default "__VITE_ASSET__BpI2QwdK__"